import WaypointListPanel from './WaypointListPanel.vue'
export default WaypointListPanel
